import { createStore, combineReducers, applyMiddleware, Reducer } from 'redux';
import thunkMiddleware from "redux-thunk";
import { createLogger } from 'redux-logger';
import { IAppStore } from "./IAppStore";
import { ProfileReducer } from './Profile/ProfileReducer'
import { ProfileActions } from './Profile/Actions';

export function configureStore() {

    const rootReducer: Reducer<IAppStore, ProfileActions> = combineReducers({
        userProfileStore: ProfileReducer
    });

    const loggerMiddleware = createLogger();

    const middleWareEnhancer = applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
    );

    let state = undefined;

    const store = createStore(rootReducer, state, middleWareEnhancer);
    return store;
}

